import { defineStore } from "pinia"
import type { VueCookies } from "vue-cookies";
import { inject } from "vue";
const keyName = "session_id"

export const useSessionIdStore = defineStore("sessionId", () => {
  const $cookies = inject<VueCookies>("$cookies");
  const getSessionId = () => {
    if (!$cookies) return '';
    return $cookies.get(keyName)
  }

  return { getSessionId };
});